export default "__VITE_ASSET__rpF8fu5e__"